import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import React from 'react';

import Constants from '../../../Constants';
import { RESOURCE_TYPE_DATA_SET } from '../../../constants/resourceTypes';
import DateUtils from '../../../lib/DateUtils';

import {
  METRICS_DATA_SETS_START_TIME,
  METRICS_DATA_SETS_START_TIME_LABEL,
} from '../../../constants/utilityConstants';
import { bytesToString, formatNumber } from '../../../lib/FormatUtils';
import DataVolumeChartViews from '../../elements/charts/DataVolumeChartViews';

import { Link } from 'react-router-dom';
import RoutePrefixContext from '../../../../new/contexts/RoutePrefixContext';
import { ROUTE_MY_DATA_SETS } from '../../../constants/pathnames';
import { SearchFilterTypes } from '../../../constants/visibilityFilters';

class AvailableDataSetCardOverviewTab extends React.Component {
  static contextType = RoutePrefixContext;

  constructor(props) {
    super(props);
    this.state = {
      graphsForDays: 7,
    };
  }

  componentDidMount() {
    this.props.fetchResourceMetricsAggregate(this.props.data.id, RESOURCE_TYPE_DATA_SET);
    let dateRange = DateUtils.getPastDateRange(this.state.graphsForDays);
    this.props.fetchResourceMetricsPerDay(this.props.data.id, RESOURCE_TYPE_DATA_SET, dateRange);
    this.props.fetchDataSetUpdateTime(this.props.data.id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data.id !== this.props.data.id) {
      this.props.fetchResourceMetricsAggregate(this.props.data.id, RESOURCE_TYPE_DATA_SET);
      let dateRange = DateUtils.getPastDateRange(this.state.graphsForDays);
      this.props.fetchResourceMetricsPerDay(this.props.data.id, RESOURCE_TYPE_DATA_SET, dateRange);
      this.props.fetchDataSetUpdateTime(this.props.data.id);
    }
  }

  _handleDateRangeChanged = (newDateRange = 7) => {
    if (newDateRange !== this.state.graphsForDays) {
      this.setState(
        {
          graphsForDays: newDateRange,
        },
        () => {
          let dateRange = DateUtils.getPastDateRange(this.state.graphsForDays);
          this.props.fetchResourceMetricsPerDay(
            this.props.data.id,
            RESOURCE_TYPE_DATA_SET,
            dateRange,
          );
        },
      );
    }
  };

  render() {
    const { data, isPublic, sharedByOrg, sharedByUser, metrics, sampleUpdateTime, summaryData } =
      this.props;
    const createdDate = DateUtils.convertDateStringToFormat(data.created_at);
    const lastUpdate = DateUtils.convertDateStringToFormat(data.updated_at);
    const sampleUpdateTimeFormatted = sampleUpdateTime
      ? DateUtils.convertDateStringToFormat(sampleUpdateTime)
      : '';

    let sharerInfo = null;
    if (isPublic === false) {
      const sharerUser = sharedByUser && sharedByUser.full_name;
      const sharerOrg = sharedByOrg && sharedByOrg.name;
      const sharerEmail = sharedByUser && sharedByUser.email;
      sharerInfo = (
        <div className="detail-value">
          {sharerUser && (
            <div>
              <b>User: </b>
              {sharerUser}
            </div>
          )}
          {sharerEmail && (
            <div>
              <b>Email: </b>
              {sharerEmail}
            </div>
          )}
          {sharerOrg && (
            <div>
              <b>Company: </b>
              {sharerOrg}
            </div>
          )}
        </div>
      );
    } else {
      sharerInfo = <div className="detail-value" />;
    }

    let metricsStartTimeLabel = '';
    if (
      data &&
      data.created_at &&
      DateUtils.getTimeDifference(data.created_at, METRICS_DATA_SETS_START_TIME) < 0
    ) {
      metricsStartTimeLabel = `(${METRICS_DATA_SETS_START_TIME_LABEL})`;
    }

    let aggregateMetrics =
      metrics && has(metrics, 'agg') && has(metrics.agg, 'metrics') ? metrics.agg.metrics : null;
    let metricsByDate =
      metrics && has(metrics, 'byDate') && !isEmpty(metrics.byDate) ? metrics.byDate : null;
    let totalVolume = '-',
      numRecords = '-';
    if (!this.props.isLoading.aggMetrics) {
      totalVolume = !isEmpty(aggregateMetrics)
        ? `${bytesToString(aggregateMetrics.size)} ${metricsStartTimeLabel}`
        : Constants.DATA_NOT_AVAILABLE;
      numRecords = !isEmpty(aggregateMetrics)
        ? `${formatNumber(aggregateMetrics.records)} ${metricsStartTimeLabel}`
        : Constants.DATA_NOT_AVAILABLE;
    }

    const derivedDataSetsCount =
      summaryData && has(summaryData, 'data_sets.total') ? summaryData.data_sets.total : null;

    return (
      <div className="tab-content">
        <section>
          <div className="detail-row">
            <div className="detail-col">
              <div className="detail-key">{isPublic ? 'Public Nexset' : 'Shared by'}</div>
              {sharerInfo}
              <div className="detail-key">Data Volume</div>
              <div className="detail-value">{totalVolume}</div>
              <div className="detail-key">Total Records</div>
              <div className="detail-value">{numRecords}</div>
              <div className="detail-key">Last Processed Data On</div>
              <div className="detail-value">{sampleUpdateTimeFormatted}</div>
            </div>
            <div className="detail-col">
              <div className="detail-key">Nexset ID</div>
              <div className="detail-value">{data.id}</div>
              <div className="detail-key">Transformed Nexsets Count</div>
              <div className="detail-value">
                <Link
                  to={`${this.context}${ROUTE_MY_DATA_SETS}?search=${SearchFilterTypes.PARENT_DATA_SET_ID}:${data.id}`}
                >
                  {derivedDataSetsCount}
                </Link>
              </div>
              <div className="detail-key">Created On</div>
              <div className="detail-value">{createdDate}</div>
              <div className="detail-key">Last Updated On</div>
              <div className="detail-value">{lastUpdate}</div>
            </div>
          </div>
          <br />
        </section>
        <hr />
        <DataVolumeChartViews
          data={metricsByDate}
          isFetchingData={this.props.isLoading.dayMetrics}
          forDateRange={this.state.graphsForDays}
          onDateRangeChanged={this._handleDateRangeChanged}
        />
      </div>
    );
  }
}

export default AvailableDataSetCardOverviewTab;
